import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GenderacceptedRoutingModule } from './genderaccepted-routing.module';
import { GenderacceptedListComponent } from './genderaccepted-list/genderaccepted-list.component';
import { GenderacceptedCreateComponent } from './genderaccepted-create/genderaccepted-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [GenderacceptedListComponent, GenderacceptedCreateComponent],
  imports: [
    CommonModule,
    GenderacceptedRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class GenderacceptedModule { }
